






























































































































































































import { VueAgile } from 'vue-agile';
import StaticContainer from './StaticContainer.vue';

export default {
  data() {
    return {
      isDesktop: !this.$store.state.isMobile,
    };
  },
  components: {
    StaticContainer,
    VueAgile,
  },
} as IView;
